export default __webpack_public_path__ + "static/auto-refill-onboarding-e823ea4d9d8e2374f538c2ffd5d3cd29.png";